
export default class OrientationHandler {

  constructor(callback) {
    this.callback = callback;
    this.mediaQuery = window.matchMedia('(orientation: landscape)');
    this.handleChange = this.handleChange.bind(this);
  }

  addListeners() {
    this.mediaQuery.addEventListener('change', this.handleChange);
    this.handleChange(this.mediaQuery);
}

  handleChange(event) {
    const orientation = event.matches ? 'landscape' : 'portrait';
    if (typeof this.callback === 'function') {
      this.callback(orientation);
    }
  }

  getCurrent() {
    return this.mediaQuery.matches ? 'landscape' : 'portrait';
  }

  destroy() {
    this.mediaQuery.removeEventListener('change', this.handleChange);
  }
}
